import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  pageContainer: {
    paddingTop: '32px'
  },
  accordion: {
    '& + &': {
      marginTop: '20px'
    },
    '& .MuiAccordionSummary-root': {
      background: palette.gradients.white,
      flexDirection: 'row-reverse',
      padding: '18px 24px'
    },
    '&.Mui-expanded': {
      marginTop: '20px'
    }
  },
  item: {
    padding: '18px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: "1px solid ".concat(palette.shades[300]),
    minHeight: '73px'
  },
  actions: {
    marginLeft: '20px',
    flexShrink: '0'
  },
  subItem: {
    padding: '18px 24px 18px 42px'
  },
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
export default useStyles;